import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const LiquidIDThumbnailsWrapper = styled(motion.div)`
    list-style-type: none;
    margin: 0;
    z-index: 5;
    display: grid;

    grid-template-areas: 'main';
    pointer-events: all;

    > * {
        grid-area: main;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        position: relative;
        place-items: center;
        place-content: center;
    }
`;

interface Props {
    $column?: boolean;
    $editing?: boolean;
}

export const ThumbnailsList = styled(motion.ul)<Props>`
    display: flex;
    list-style-type: none;
    margin: 0;
    justify-content: flex-start;
    row-gap: 20px;
    column-gap: 20px;
    z-index: 5;
    overflow-x: scroll;
    position: fixed;
    width: 100vw;
    bottom: 60px;
    align-items: flex-end;
    pointer-events: all;
    padding: 0 20px 40px 20px;
    height: 110px;

    ${({ $editing }) =>
        $editing &&
        css`
            height: 100vh;
            bottom: 40px;
        `}

    ::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        justify-content: center;
        overflow-x: initial;
        width: initial;
        bottom: unset;
        top: 0;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        position: relative;
        width: initial;
        height: initial;
        align-items: initial;
        padding: 0;
    }

    ${({ $column }) =>
        $column &&
        css`
            flex-direction: column;
        `}
`;

interface ThumbnailWrapperProps {
    $draggable?: boolean;
    $dimOnDrag?: boolean;
    $highlight?: boolean;
    $userDragging?: boolean;
}

export const OuterThumbnailWrapper = styled(motion.li)<ThumbnailWrapperProps>`
    transition: opacity ${({ theme }) => `${theme.transitions.speeds.fast}s ${theme.transitions.easesCss.cubic}`};
    opacity: ${({ $dimOnDrag, $userDragging }) => ($dimOnDrag && $userDragging ? 0.3 : 1)};
    position: relative;
`;

export const ThumbnailWrapper = styled.div<ThumbnailWrapperProps>`
    position: relative;
    z-index: 0;
`;
